<template>
  <div class="py-4 container-fluid">
    <div class="d-sm-flex jmy-auto mt-4 ms-auto mt-lg-0">
      <div class="my-auto ms-auto">
        <SoftButton data-bs-toggle="modal" data-bs-target="#requeueModal"
          class="mt-2 mb-0 btn bg-gradient-success ms-lg-3 me-lg-0 me-auto mt-lg-0 ">
          <i class="fa fa-share" aria-hidden="true"></i>
          Reencolar
        </SoftButton>
        <FilterDate :value-date=filters.date @filter-change="onDateFilterChange" @clean-filter-date="onCleanFilterDate"/>
        <filter-status :filter-status-selected="filterStatusSelected" @filter-change="onFilterStatusChange"/>
        <Filter :filter-status-selected="filterQueueSelected" @filter-change="onFilterChange" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card mt-4">
          <div class="table-responsive p-4">
            <full-table v-if="!!queuesData" :items="queuesData.items" :pagination="pagination" 
              :headers="headers" @changed-page="paginationPageChange" @row-change="paginationRowChange"
              @header-change="onHeaderChange" @search-change="onSearchChange" @reload-clicked="getQueues">
              <template #row="queuedata">
                <td class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{$dateUtils.toDDMMYYYYHH(queuedata.date)}}</span>
                </td>
                <td class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{queuedata._id}}</span>
                </td>
                <td class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{queuedata.number}}</span>
                </td>
                <td class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{queuedata.customer}}</span>
                </td>
                <td class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{queuedata.type}}</span>
                </td>
                <td class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{queuedata.attempts}}</span>
                </td>
                <td class="text-xs font-weight-bold">
                  <div v-if="queuedata.status=='FINALIZADO'" class="d-flex align-items-center">
                      <soft-button color="success" variant="outline"
                        class="btn-icon-only btn-rounded mb-0 me-2 btn-sm d-flex align-items-center justify-content-center">
                        <i class="fas fa-check" aria-hidden="true"></i>
                      </soft-button>
                      <span>{{ queuedata.status }}</span>
                    </div>
                    <div v-else-if="queuedata.status == 'PENDIENTE'" class="d-flex align-items-center">
                        <soft-button color="primary" variant="outline"
                          class="btn-icon-only btn-rounded mb-0 me-2 btn-sm d-flex align-items-center justify-content-center">
                          <i class="fas fa-exclamation" aria-hidden="true"></i>
                        </soft-button>
                        <span>{{ queuedata.status }}</span>
                      </div>
                    <div v-else class="d-flex align-items-center">
                      <soft-button color="danger" variant="outline"
                        class="btn-icon-only btn-rounded mb-0 me-2 btn-sm d-flex align-items-center justify-content-center">
                        <i class="fas fa-exclamation"></i>
                      </soft-button>
                      <span style="cursor:pointer">{{queuedata.status}}</span>
                    </div>
                </td>
                <td class="text-sm" style="width: 10rem">
                  <a class="mx-3" title="Ver Detalles" style="cursor:pointer" data-bs-toggle="modal"
                    data-bs-target="#queueRequestModal" @click="getDetails(queuedata._id)">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </a>
                </td>
              </template>
            </full-table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <queue-details :queue-info="queueInfo" />
  <re-queue-modal @confirm-requeue="confirmRequeue"/>
  <div class="position-fixed top-8 end-2 z-index-2">
      <soft-snackbar
        :show="showNotification"
        :title="notificationInfo.title"
        :description="notificationInfo.message"
        :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
        :color="notificationInfo.status=='success'?'success':'danger'"
        @close-handler="showNotification = !showNotification"
      />
    </div>
</template>

<script>
import { FullTable } from "@/hotaka/components";
import Filter from "./components/Filter.vue";
import FilterDate from "./components/FilterDate.vue";
import QueueDetails from "./components/QueueDetails.vue";
import SoftButton from '@/components/SoftButton.vue';
import FilterStatus from "./components/FilterStatus.vue";
import ReQueueModal from './components/ReQueueModal.vue';
import SoftSnackbar from "@/components/SoftSnackbar.vue";

export default {
 name: "QueueList",
 components: {
   FullTable,
   Filter,
   FilterDate,
   QueueDetails,
   SoftButton,
   FilterStatus,
  ReQueueModal,
  SoftSnackbar
 },
 data()  {
   return{
    filterQueueSelected: 'from_sga_queue',
    filterStatusSelected: 'ERROR',
     pagination: {
       total: 0,
       rows: 10,
       currentPage: 1,
       pages: {
         total: 10,
         current: 1
       },
       entries: [5, 10, 15, 20, 50]
     },
     headers:[
       {title:'Creado',sort:{sorteable:true,order:""}, column: "date"},
       {title:'ID',sort:{sorteable:false,order:""}, column: "_id"},
       {title:'Número',sort:{sorteable:false,order:""}, column: "number"},
       {title:'Cliente',sort:{sorteable:false,order:""}, column: "customer"},
       {title:'Tipo',sort:{sorteable:false,order:""}, column: "type"},
       {title:'Intentos',sort:{sorteable:false,order:""}, column: "attempts"},
       {title:'Estado',sort:{sorteable:false,order:""}, column: "status"},
       {title:'Acciones',sort:{sorteable:false,order:""}},
       
     ],
     filters:{
       search: '',
       queue:'from_sga_queue',
       status:'ERROR',
       sort:{
         sort:'',
         order:''
       },
       date: {
          start: '',
          end:''
        }
     },
     queueInfo:{},
     showNotification: false,
     notificationInfo:{
        title: '',
        message: '',
        status: 'danger'
      },
   }
 },
 computed: {
   queuesData() {
     return this.$store.state.queue.list.data;
   },
  queue() {
      return  this.$store.state.queue.queue.data;
  },
  requeueStatus() {
      return  this.$store.state.queue.requeue.status;
  }
 },
 watch: {
   queuesData() {
     if(this.queuesData){
       this.pagination.total= this.queuesData.total;
     }
   },
   queue(newValue){
    if(newValue){
      this.queueInfo=newValue;
    }
   },
   requeueStatus(val) {
      if (val.requeued) {
        if (this.$store.state.queue.requeue.data) {
          this.notificationInfo = {
            title: 'Reencolado con exito!',
            message: "Cola Reencolada!",
            status: 'success'
          }
          this.showNotification = true;
          this.closeNotification()
          setTimeout(() => {
            this.filters.status='PENDIENTE';
            this.filterStatusSelected='PENDIENTE';
            this.getQueues();
          }, 200);
        }
      } else if (val.error) {
        let message="Ha ocurrido un error al crear el embalaje";
        const error= val.error.error;
        if (error) {
          message = error
        }
        this.notificationInfo = {
          title: 'Ups! Error',
          message: message,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification()
      }
    },
 },
 mounted() {
  if (Object.keys(this.$route.query).length > 0) {
      this.filterStatusSelected = this.$route.query.status;
      this.filterQueueSelected= this.$route.query.entity;
      this.filters.status = this.$route.query.status;
      this.filters.queue= this.$route.query.entity;
    }
  this.defaultRangeDate();
  this.getQueues();
 },
 methods: {
   getQueues() {
     this.$store.commit("queue/load",{pagination:this.pagination,filters: this.filters});
   },
   getDetails(entityId){
    this.$store.commit("queue/getById",{id:entityId,entity: this.filters.queue});
   },
   paginationPageChange(page) {
     this.pagination.currentPage = page;
     this.getQueues(); 
   },
   paginationRowChange(rows) {
     this.pagination.rows = rows;
     this.getQueues(); 
   },
   onHeaderChange(val){
     this.filters.sort={
       sort: val.column,
       order: val.order=='asc'? "ascending": "descending"
     }
     this.getQueues(); 
   },
   onFilterChange(value){
      this.pagination.currentPage = 1;
      this.filterQueueSelected = value
      this.filters.queue=value;
      this.getQueues();
    },
    onDateFilterChange(value){
      this.filters.date= value
      this.getQueues();
    },
    onFilterStatusChange(value){
      this.filterStatusSelected= value
      this.filters.status= value
      this.getQueues();
    },
    onSearchChange(value){
      this.pagination.currentPage = 1;
      this.filters.search=value;
      this.getQueues(); 
    },
    confirmRequeue(){
    this.$store.commit("queue/requeue",this.filters);
    },
    closeNotification(){
      const self= this;
      setTimeout(function () {
        self.showNotification = false
      }, 2700);
    },
    defaultRangeDate(){
      const fecha = new Date();
  
      const ago7 = new Date(
        fecha.getFullYear(),
        fecha.getMonth(),
        fecha.getDate()-7
      );
      const today= new Date(
        fecha.getFullYear(),
        fecha.getMonth(),
        fecha.getDate()
      );
      
      this.filters.date.start=this.$dateUtils.toFormat(ago7, 'yyyy-MM-DD');
      this.filters.date.end= this.$dateUtils.toFormat(today,'yyyy-MM-DD');
    },
    onCleanFilterDate(){
      this.defaultRangeDate();
      this.getQueues();
    }
 }
};
</script>
<style scoped>
.columns {
 max-width: 150px;
}
.image{
 height: 2.2rem !important;
 border-radius: 9%;
}

.overflow-column {
 overflow: hidden;
 text-overflow: ellipsis;
}

.pointer {
 cursor: pointer;
}
</style>
